import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import Card from '../common/Card';
import Button from '../common/Button';
import Modal from '../common/Modal';
import Input from '../common/Input';
import Loading from '../common/Loading';
import AssignAssociationToSimpleModal from './AssignAssociationToSimpleModal'; // ← NOUVEAU

const SimpleList = () => {
  const { user } = useAuth();
  const [simples, setSimples] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedSimple, setSelectedSimple] = useState(null);
  const [showAssignModal, setShowAssignModal] = useState(false); // ← NOUVEAU
  const [simpleToAssign, setSimpleToAssign] = useState(null); // ← NOUVEAU
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });

  useEffect(() => {
    fetchSimples();
  }, []);

  const fetchSimples = async () => {
    try {
      const response = await api.get(`/simples/owner/${user.id}`);
      setSimples(response.data.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/simples/owner/${user.id}`, formData);
      setShowModal(false);
      setFormData({ name: '', email: '', password: '' });
      fetchSimples();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors de la création');
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await api.put(`/simples/${selectedSimple._id}`, {
        name: formData.name,
        email: formData.email,
      });
      setShowModal(false);
      setEditMode(false);
      setSelectedSimple(null);
      setFormData({ name: '', email: '', password: '' });
      fetchSimples();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur lors de la modification');
    }
  };

  const handleToggleActive = async (id) => {
    try {
      await api.patch(`/simples/${id}/toggle-active`);
      fetchSimples();
    } catch (error) {
      alert(error.response?.data?.message || 'Erreur');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce user_simple ?')) {
      try {
        await api.delete(`/simples/${id}`);
        fetchSimples();
      } catch (error) {
        alert(error.response?.data?.message || 'Erreur lors de la suppression');
      }
    }
  };

  const openEditModal = (simple) => {
    setSelectedSimple(simple);
    setFormData({
      name: simple.name,
      email: simple.email,
      password: '',
    });
    setEditMode(true);
    setShowModal(true);
  };

  const openCreateModal = () => {
    setSelectedSimple(null);
    setFormData({ name: '', email: '', password: '' });
    setEditMode(false);
    setShowModal(true);
  };

  // ← NOUVELLE FONCTION
  const handleAssignAssociation = (simple) => {
    setSimpleToAssign(simple);
    setShowAssignModal(true);
  };

  if (loading) return <Loading />;

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Mes User Simples</h1>
        <Button onClick={openCreateModal}>+ Nouveau Simple</Button>
      </div>

      <Card>
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Nom
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Email
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Association
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Statut
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {simples.length > 0 ? (
                simples.map((simple) => (
                  <tr key={simple._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="w-10 h-10 rounded-full bg-purple-500 text-white flex items-center justify-center font-bold">
                          {simple.name.charAt(0).toUpperCase()}
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">
                            {simple.name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {simple.email}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {simple.associationId ? (
                        <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full">
                          {simple.associationId.name || 'Assignée'}
                        </span>
                      ) : (
                        <span className="px-2 py-1 text-xs bg-gray-100 text-gray-500 rounded-full">
                          Aucune
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span
                        className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          simple.active
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                        }`}
                      >
                        {simple.active ? 'Actif' : 'Inactif'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2">
                      {/* ← NOUVEAU BOUTON */}
                      <Button
                        variant="primary"
                        onClick={() => handleAssignAssociation(simple)}
                        className="text-xs"
                      >
                        🔗 Association
                      </Button>
                      <Button
                        variant="secondary"
                        onClick={() => openEditModal(simple)}
                        className="text-xs"
                      >
                        Modifier
                      </Button>
                      <Button
                        variant={simple.active ? 'danger' : 'success'}
                        onClick={() => handleToggleActive(simple._id)}
                        className="text-xs"
                      >
                        {simple.active ? 'Désactiver' : 'Activer'}
                      </Button>
                      <Button
                        variant="danger"
                        onClick={() => handleDelete(simple._id)}
                        className="text-xs"
                      >
                        Supprimer
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                    Aucun user_simple. Créez-en un pour commencer !
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="mt-4 text-sm text-gray-600">
          Total: {simples.length} user_simple(s)
        </div>
      </Card>

      {/* Modal Création/Modification */}
      <Modal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          setEditMode(false);
          setSelectedSimple(null);
        }}
        title={editMode ? 'Modifier un user_simple' : 'Créer un user_simple'}
      >
        <form onSubmit={editMode ? handleUpdate : handleCreate}>
          <Input
            label="Nom"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
          <Input
            label="Email"
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
          />
          {!editMode && (
            <Input
              label="Mot de passe"
              type="password"
              value={formData.password}
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
              required
            />
          )}
          <div className="flex justify-end space-x-3 mt-6">
            <Button
              variant="secondary"
              onClick={() => {
                setShowModal(false);
                setEditMode(false);
                setSelectedSimple(null);
              }}
            >
              Annuler
            </Button>
            <Button type="submit">{editMode ? 'Modifier' : 'Créer'}</Button>
          </div>
        </form>
      </Modal>

      {/* ← NOUVEAU MODAL */}
      {showAssignModal && simpleToAssign && (
        <AssignAssociationToSimpleModal
          simple={simpleToAssign}
          onClose={() => {
            setShowAssignModal(false);
            setSimpleToAssign(null);
          }}
          onSuccess={() => {
            setShowAssignModal(false);
            setSimpleToAssign(null);
            fetchSimples();
          }}
        />
      )}
    </div>
  );
};

export default SimpleList;